import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessMessage = ({ message, onClose }) => {
  return (
    <div className="flex flex-col items-center justify-center py-6 md:py-8 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#9AE6B4] flex items-center justify-center mb-4 md:mb-6">
        <Icon name="Check" size={32} color="#1A1A1A" strokeWidth={3} />
      </div>
      
      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2 md:mb-3 text-center">
        Success!
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center mb-6 md:mb-8 max-w-md">
        {message}
      </p>
      
      <button
        onClick={onClose}
        className="px-6 py-2 md:px-8 md:py-3 bg-primary text-primary-foreground rounded-lg font-medium text-sm md:text-base hover:opacity-90 transition-smooth"
      >
        Close
      </button>
    </div>
  );
};

export default SuccessMessage;